import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CartContext } from '../context/CartContext';
//import { poojaItems } from '../data/mockData';
import Card from '../components/Card';

const PoojaItemsPage = () => {
  const { cart, total } = useContext(CartContext);
  return (
    <div className="pp-main-container">
      <header className="page-header">
        <motion.h1 initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }}>
          Pooja Essentials
        </motion.h1>
        <p>Premium quality items for your sacred rituals.</p>
      </header>

      {/* <motion.div 
        className="pp-grid"
        initial="hidden" animate="show"
        variants={{ hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.1 } } }}
      >
        {poojaItems.map(item => (
          <Card key={item.id} item={{ ...item, type: 'pooja-item' }} showAddToCart={true} />
        ))}
      </motion.div> */}
    </div>
  );
};

export default PoojaItemsPage;